import React from 'react'
import { motion } from 'framer-motion'


export default function ComingSoon() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-900 to-blue-700 text-white p-8 flex flex-col justify-between">
     

      <main className="flex-grow flex flex-col items-center justify-center">
        <div className="w-full max-w-screen-lg bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg p-8 rounded-lg">
          <h1 className="text-3xl font-bold text-center">Próximamente</h1>
          <p className="text-center">
            Estamos desarrollando actualizaciones para traerte la mejor experiencia en gestión de camping.
          </p>
          <div className="relative h-80 overflow-hidden rounded-lg mt-8">
            {/* Cielo del atardecer */}
            <div className="absolute inset-0 bg-gradient-to-b from-orange-300 via-pink-500 to-purple-700" />
            
            {/* Sol del atardecer */}
            <motion.div
              className="absolute top-4 right-4 w-24 h-24 rounded-full bg-gradient-to-b from-yellow-400 to-orange-500 shadow-lg"
              animate={{
                scale: [1, 1.05, 1],
              }}
            />
            {/* Nubes del atardecer */}
            {[
                { top: '15%', left: '10%', delay: 0 },
                { top: '25%', left: '35%', delay: 2 },
                { top: '10%', left: '60%', delay: 1 },
              ].map((cloud, index) => (
                <motion.div
                  key={index}
                  className="absolute"
                  style={{ top: cloud.top, left: cloud.left }}
                  animate={{
                    x: [0, 20, 0],
                  }}
                  transition={{
                    repeat: Infinity,
                    duration: 10,
                    delay: cloud.delay,
                    ease: "linear",
                  }}
                >
                  <svg width="120" height="40" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 30 Q30 20 50 30 T90 30 Q110 30 110 20 T90 10 Q70 0 50 10 T10 10 Q0 10 0 20 T10 30" fill="url(#cloudGradient)" />
                    <defs>
                      <linearGradient id="cloudGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#FFB6C1" />
                        <stop offset="100%" stopColor="#FFA07A" />
                      </linearGradient>
                    </defs>
                  </svg>
                </motion.div>
              ))}
              
              {/* Agua del atardecer */}
              <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-b from-purple-700 to-blue-900">
                {[0, 1, 2].map((index) => (
                  <motion.div
                    key={index}
                    className="absolute inset-0"
                    style={{
                      background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='%23ffffff' fill-opacity='${0.1 + index * 0.05}' d='M0,128L48,154.7C96,181,192,235,288,234.7C384,235,480,181,576,165.3C672,149,768,171,864,181.3C960,192,1056,192,1152,170.7C1248,149,1344,107,1392,85.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z'%3E%3C/path%3E%3C/svg%3E")`,
                      backgroundSize: "200% 100%",
                      backgroundRepeat: "repeat-x",
                    }}
                    animate={{
                      x: [0, -1440, 0],
                    }}
                    transition={{
                      repeat: Infinity,
                      duration: 20 + index * 5,
                      ease: "linear",
                    }}
                  />
                ))}
              </div>

              {/* Velero */}
              <motion.div
                className="absolute bottom-1/4 left-1/2 transform -translate-x-1/2"
                animate={{
                  y: [0, -5, 0],
                }}
                transition={{
                  repeat: Infinity,
                  duration: 2,
                  ease: "easeInOut",
                }}
              >
                <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/* Casco del velero */}
                  <path d="M20 140 L100 140 L180 140 L160 180 L40 180 Z" fill="#8B4513" />
                  <path d="M30 145 L170 145" stroke="#6B3E26" strokeWidth="2" />
                  <path d="M40 150 L160 150" stroke="#6B3E26" strokeWidth="2" />
                  <path d="M50 155 L150 155" stroke="#6B3E26" strokeWidth="2" />
                  
                  {/* Cabina */}
                  <rect x="80" y="110" width="40" height="30" fill="#D2691E" />
                  <rect x="85" y="115" width="10" height="10" fill="#87CEEB" />
                  <rect x="105" y="115" width="10" height="10" fill="#87CEEB" />
                  
                  {/* Mástil principal */}
                  <rect x="98" y="20" width="4" height="120" fill="#8B4513" />
                  
                  {/* Vela mayor */}
                  <path d="M100 20 Q130 60 140 140 L100 140 Z" fill="#FFF5E6" stroke="#000000" strokeWidth="1" />
                  
                  {/* Botavara */}
                  <path d="M100 100 L150 100" stroke="#8B4513" strokeWidth="4" />
                  
                  {/* Foque */}
                  <path d="M100 40 Q70 90 20 140 L100 140 Z" fill="#FFF5E6" stroke="#000000" strokeWidth="1" />
                  
                  {/* Estay de proa */}
                  <path d="M100 20 L20 140" stroke="#000000" strokeWidth="1" />
                  
                  {/* Obenques */}
                  <path d="M100 20 L70 140" stroke="#000000" strokeWidth="1" />
                  <path d="M100 20 L130 140" stroke="#000000" strokeWidth="1" />
                  
                  {/* Timón */}
                  <path d="M170 140 Q172 150 170 160" stroke="#8B4513" strokeWidth="3" />
                  
                  {/* Bandera */}
                  <rect x="98" y="15" width="20" height="10" fill="#FF6347" />
                  
                  {/* Detalles */}
                  <circle cx="30" cy="135" r="3" fill="#FFD700" /> {/* Luz de navegación */}
                  <circle cx="170" cy="135" r="3" fill="#FFD700" /> {/* Luz de navegación */}
                </svg>
              </motion.div>
            </div>
          <p className="text-center mt-8">
          DRIZA: Gestión inteligente para campings y embarcaciones.
          </p>
        </div>
      </main>
    </div>
  );
}